// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_KEY : '48d38e5dec37513a254d203939f893f2',
  Container_URL1: 'https://www.shipco.com/s3w/container-names-scan',
  Container_URL2: 'https://www.shipco.com/s3w/container-specification-scan',
  INCO_URL_1 : 'https://www.shipco.com/s3w/INCO-terms-scan',
  INCO_URL_2 : 'https://www.shipco.com/s3w/INCO-terms-details-scan',
  Vessel_Tracker_URL_1: 'https://www.shipco.com/s3w/vessel-tracker-vesselname-scan',
  Vessel_Tracker_URL_2: 'https://www.shipco.com/s3w/vessel-tracker-details-scan',
  Emission_calc_URL_1 : 'https://www.shipco.com/s3w/emission-calculator-addresses-scan',
  Emission_calc_URL_2 : 'https://www.shipco.com/s3w/',
  Emission_calc_URL_3 : 'https://www.shipco.com/s3w/emission-calculator-calculate-scan',
  freight_vol_calc_URL_1:'https://www.shipco.com/s3w/ocean-freight-volume-calculator-allunits-scan',
  freight_vol_calc_URL_2: 'https://www.shipco.com/s3w/ocean-freight-volume-calculator-formula-scan',
  Shipping_glossary_URL_1: 'https://api.scan-shipping.com/api/gloassaries.php',
  Shipping_glossary_URL_2: 'https://api.scan-shipping.com/api/gloassaries.php'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
